import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface GradientHeadingProps {
  children: ReactNode;
  className?: string;
  level?: "h1" | "h2" | "h3";
  size?: "sm" | "md" | "lg" | "xl";
  align?: "left" | "center" | "right";
}

export const GradientHeading = ({ 
  children, 
  className, 
  level = "h2",
  size = "lg",
  align = "left"
}: GradientHeadingProps) => {
  const Component = level;
  
  const sizeClasses = {
    sm: "text-xl sm:text-2xl",
    md: "text-2xl sm:text-4xl",
    lg: "text-3xl sm:text-5xl",
    xl: "text-4xl sm:text-6xl"
  };
  
  const alignClasses = {
    left: "text-left",
    center: "text-center", 
    right: "text-right"
  };
  
  return (
    <Component 
      className={cn(
        sizeClasses[size],
        "font-display font-extralight bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent mb-4 sm:mb-6 leading-[1.3] break-words py-2",
        "[text-shadow:0_0_0_transparent] will-change-transform", // Prevents text clipping
        alignClasses[align],
        className
      )}
      style={{
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        // Fallback for better compatibility
        backgroundImage: 'linear-gradient(135deg, hsl(var(--foreground)), hsl(var(--foreground)), hsl(var(--primary)))'
      }}
    >
      {children}
    </Component>
  );
};